import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { BASE_URL, API } from 'CONST';
import { Container, Col, Row } from 'reactstrap';
import NumberFormat from 'react-number-format';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { detalleTripleLines, handleKey, detalleListNotVentaVerde } from 'helpers/helpers';
import PageContainer from './PageContainer';
import { get, post, rDelete } from '../helpers/requests';
import EditLineModal from './EditLineModal';
import WarningModal from './UI/WarningModal';
import DetailCard from './DetailCard';
import TripleLineCard from './TripleLineCard';
import Icon from './UI/Icon';
import MovimientoListDetail from './MovimientoListDetail';
import RowCardsGroup from './RowCardsGroup';

const ClientDetail = ({ match }) => {
  const clientIsAfianzadoVentaEnVerde = (client) => {
    return client.organizacion.roles.includes('afianzadoventaenverde');
  };

  const { params } = match;
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [aumento, setAumento] = useState(false);
  const [lastClientDetail, setLastClientDetail] = useState({
    organizacion: {
      nombre: '',
      rut: '',
      roles: [],
    },
    balance: {
      bloqueada: false,
      cumulo: 0,
      cumulo_indirecto: 0,
      cumulo_proyectos: 0,
      linea: 0,
      limite_contrafianza: 0,
      linea_indirecta: 0,
      linea_proyectos: 0,
      exposicion_maxima: 0,
    },
  });
  const [borrador, setBorrador] = useState(undefined);
  const [activeLine, setActiveLine] = useState('');
  const [activeData, setActiveData] = useState(undefined);
  const [update, setUpdate] = useState(false);
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    toggle: () => {},
    handleOk: () => {},
    loading: false,
    okBtnText: '',
    confirmMsg: '',
  });
  const [activeMovement, setActiveMovement] = useState(undefined);
  const [approvedSuccess, setApprovedSuccess] = useState(false);

  const getLastClient = () => {
    get(`${BASE_URL}${API.lineasGarantia}${params.id}`).then((response) => {
      setLastClientDetail(response);
    });
  };

  const resetData = () => {
    setApprovedSuccess(false);
  };

  const resetBorrador = () => {
    setBorrador(undefined);
  };

  useEffect(() => {
    getLastClient();
  }, []);

  useEffect(() => {
    if (approvedSuccess) {
      getLastClient();
      resetData();
    }
    if (!editModalOpen) {
      resetBorrador();
    }
  }, [editModalOpen, approvedSuccess]);

  const handleModal = () => {
    setEditModalOpen(!editModalOpen);
  };

  const updateFunc = () => {
    setUpdate((prevState) => !prevState);
  };

  const handleLineSuccess = (data) => {
    setActiveData(data);
    setEditModalOpen(false);
    updateFunc();
    getLastClient();
    resetData();
  };

  const handleEdit = (e, node, newAumento) => {
    e.preventDefault();
    const newActiveLine = { ...node };
    newActiveLine.monto = lastClientDetail.balance[node.nemotecnico];
    setAumento(newAumento);
    setActiveLine(newActiveLine);
    setEditModalOpen(true);
  };

  const handleView = (e, i, indirecta) => {
    e.preventDefault();
    resetData();
    setActiveData(indirecta ? i : i.nemotecnico);
  };

  const toggleConfirmationModal = () => {
    setConfirmModal((prevState) => ({
      ...prevState,
      isOpen: !prevState.isOpen,
    }));
  };

  const handleBlockLineSubmit = () => {
    setConfirmModal((prevState) => ({
      ...prevState,
      loading: true,
    }));
    const config = {
      linea_garantia: lastClientDetail.id,
      tipo_id: 4,
      tipo_cambio_id: lastClientDetail.balance.bloqueada ? 2 : 1,
    };
    post(`${BASE_URL}${API.movimientos}`, config).then((response) => {
      setConfirmModal((prevState) => ({
        ...prevState,
        loading: false,
        isOpen: false,
      }));
      setLastClientDetail((prevState) => ({
        ...prevState,
        balance: response.balance,
      }));
    });
  };

  const handleDeleteMovementSubmit = () => {
    setConfirmModal((prevState) => ({
      ...prevState,
      loading: true,
    }));
    rDelete(`${BASE_URL}${API.movimientos}${activeMovement.id}/`).then(() => {
      updateFunc();
      getLastClient();
      setConfirmModal((prevState) => ({
        ...prevState,
        loading: false,
        isOpen: false,
      }));
    });
  };

  const updateConfirmationModal = (mode) => {
    const newConfirmModal = {
      isOpen: true,
      loading: false,
    };
    switch (mode) {
      case 'block-line':
        newConfirmModal.toggle = toggleConfirmationModal;
        newConfirmModal.handleOk = handleBlockLineSubmit;
        newConfirmModal.okBtnText = 'Bloquear línea';
        newConfirmModal.confirmMsg = 'Estás por bloquear esta línea de garantía';
        break;
      case 'unblock-line':
        newConfirmModal.toggle = toggleConfirmationModal;
        newConfirmModal.handleOk = handleBlockLineSubmit;
        newConfirmModal.okBtnText = 'Desbloquear línea';
        newConfirmModal.confirmMsg = 'Estás por desbloquear esta línea de garantía';
        break;
      case 'delete-movement':
        newConfirmModal.toggle = toggleConfirmationModal;
        newConfirmModal.handleOk = handleDeleteMovementSubmit;
        newConfirmModal.okBtnText = 'Eliminar';
        newConfirmModal.confirmMsg = 'Estás por eliminar este movimiento';
        break;
      default:
        break;
    }
    setConfirmModal(newConfirmModal);
  };

  const activeMovementSetter = (e, newActiveMovement) => {
    e.preventDefault();
    setActiveMovement(newActiveMovement);
  };

  useEffect(()=>{
    if(activeMovement){
      updateConfirmationModal('delete-movement');
    }
  },[activeMovement])


  const setActiveInstance = () => {
    if (lastClientDetail.balance.bloqueada) {
      updateConfirmationModal('unblock-line');
    } else {
      updateConfirmationModal('block-line');
    }
  };

  const handleEditBorrador = (e, newBorrador, line) => {
    e.preventDefault();
    const newActiveLine = { ...line };
    const isAumento = newBorrador.tipo_cambio.id === 1;
    newActiveLine.monto = newBorrador.balance[line.nemotecnico];
    setAumento(isAumento);
    setBorrador(newBorrador);
    setActiveLine(newActiveLine);
    setEditModalOpen(true);
  };

  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'RIESGO', url: '/' },
        { id: 1, name: 'GARANTÍA', url: '/' },
        { id: 2, name: 'DETALLE CLIENTE' },
      ]}
    >
      {editModalOpen && (
        <EditLineModal
          aumento={aumento}
          afianzado={lastClientDetail.organizacion}
          borrador={borrador}
          handleModal={handleModal}
          id={lastClientDetail.id}
          limite={lastClientDetail.balance.limite_contrafianza}
          linea={activeLine}
          lineaGarantia={lastClientDetail.id}
          lineSuccess={handleLineSuccess}
          modalOpen={editModalOpen}
        />
      )}

      <WarningModal
        isOpen={confirmModal.isOpen}
        toggle={confirmModal.toggle}
        handleOk={confirmModal.handleOk}
        loading={confirmModal.loading}
        okBtnText={confirmModal.okBtnText}
        confirmMsg={confirmModal.confirmMsg}
      />

      <Container fluid>
        {lastClientDetail !==null &&
        lastClientDetail.organizacion &&
        lastClientDetail.organizacion.grupo &&
        (
          <div>
            <Row className='client-detail'>
              <Col>
                <div className='detail-title'>
                  <h5>
                    { `${lastClientDetail.organizacion.grupo.nombre}` }
                  </h5>
                </div>
              </Col>
            </Row>
            <RowCardsGroup
              grupoId={lastClientDetail.organizacion.grupo.id}
            />
          </div>
        )}
        <Row className="client-detail">
          <Col>
            <div className="detail-title">
              <h5>
                {lastClientDetail &&
                  lastClientDetail !== null &&
                  `${lastClientDetail.organizacion.nombre} - ${lastClientDetail.organizacion.rut}`}
              </h5>
            </div>
          </Col>
        </Row>
        {lastClientDetail !== null &&
        lastClientDetail &&
        clientIsAfianzadoVentaEnVerde(lastClientDetail) ? (
          <Row className="cards-container">
            {lastClientDetail !== null && lastClientDetail && (
              <Col sm="3" xs="6">
                <DetailCard
                  key={1}
                  detail={lastClientDetail}
                  handleEdit={handleEdit}
                  handleView={handleView}
                  node={{
                    tipo_id: 1,
                    label: 'Exposición Máxima',
                    nemotecnico: 'exposicion_maxima',
                  }}
                />
              </Col>
            )}
            {lastClientDetail !== null &&
              lastClientDetail &&
              detalleTripleLines.map((node) => (
                <Col sm="3" xs="6" key={node.block_id}>
                  <TripleLineCard
                    key={node.block_id}
                    detail={lastClientDetail}
                    handleEdit={node.block_name === 'Cumulos' ? setActiveInstance : handleEdit}
                    handleView={handleView}
                    node={{
                      block_name: node.block_name,
                      blick_id: node.block_id,
                      label_first: node.label_first,
                      nemotecnico_first: node.nemotecnico_first,
                      tipo_id_first: node.tipo_id_first,
                      label_second: node.label_second,
                      nemotecnico_second: node.nemotecnico_second,
                      tipo_id_second: node.tipo_id_second,
                      total: node.total,
                    }}
                  />
                </Col>
              ))}

            {lastClientDetail && lastClientDetail !== null && (
              <Col sm="3" xs="6">
                <div className="card-wrapper indirecta">
                  <Row className="indirecta d-flex justify-content-between">
                    <div className="text-left font-weight-bold">Línea Indirecta</div>
                    <div>
                      <NumberFormat
                        decimalScale="2"
                        fixedDecimalScale
                        decimalSeparator=","
                        displayType="text"
                        value={lastClientDetail.balance.linea_indirecta}
                        thousandSeparator="."
                      />
                      &nbsp;
                      <Icon
                        className="detail"
                        handleOnClick={(e) => handleView(e, 'linea_indirecta', true)}
                        id="show-linea-indirecta"
                        placement="right"
                        tooltipText={<span className="show-tooltip">Ver Tabla</span>}
                      >
                        <FontAwesomeIcon className="table-link" icon={faSearch} />
                      </Icon>
                    </div>
                  </Row>
                  <Row className="indirecta d-flex justify-content-between">
                    <div className="text-left font-weight-bold">Cúmulo Indirecto</div>
                    <div>
                      <NumberFormat
                        decimalScale="2"
                        fixedDecimalScale
                        decimalSeparator=","
                        displayType="text"
                        value={lastClientDetail.balance.cumulo_indirecto}
                        thousandSeparator="."
                      />
                      &nbsp;
                      <Icon
                        className="detail"
                        handleOnClick={(e) => handleView(e, 'cumulo_indirecto', true)}
                        id="show-cumulo-indirecto"
                        placement="right"
                        tooltipText={<span className="show-tooltip">Ver Tabla</span>}
                      >
                        <FontAwesomeIcon className="table-link" icon={faSearch} />
                      </Icon>
                    </div>
                  </Row>
                </div>
              </Col>
            )}
          </Row>
        ) : (
          <Row className="cards-container">
            {lastClientDetail !== null &&
              lastClientDetail &&
              detalleListNotVentaVerde.map((node) => (
                <Col sm="3" xs="6" key={node.tipo_id}>
                  <DetailCard
                    key={node.tipo_id}
                    detail={lastClientDetail}
                    handleEdit={
                      node.nemotecnico === 'cumulo' || node.nemotecnico === 'cumulo_proyectos'
                        ? setActiveInstance
                        : handleEdit
                    }
                    handleView={handleView}
                    node={node}
                  />
                </Col>
              ))}
            {lastClientDetail && lastClientDetail !== null && (
              <Col sm="3" xs="6">
                <div className="card-wrapper indirecta">
                  <Row className="indirecta d-flex justify-content-between">
                    <div className="text-left font-weight-bold">Línea Indirecta</div>
                    <div>
                      <NumberFormat
                        decimalScale="2"
                        fixedDecimalScale
                        decimalSeparator=","
                        displayType="text"
                        value={lastClientDetail.balance.linea_indirecta}
                        thousandSeparator="."
                      />
                      &nbsp;
                      <Icon
                        className="detail"
                        handleOnClick={(e) => handleView(e, 'linea_indirecta', true)}
                        id="show-linea-indirecta"
                        placement="right"
                        tooltipText={<span className="show-tooltip">Ver Tabla</span>}
                      >
                        <FontAwesomeIcon className="table-link" icon={faSearch} />
                      </Icon>
                    </div>
                  </Row>
                  <Row className="indirecta d-flex justify-content-between">
                    <div className="text-left font-weight-bold">Cúmulo Indirecto</div>
                    <div>
                      <NumberFormat
                        decimalScale="2"
                        fixedDecimalScale
                        decimalSeparator=","
                        displayType="text"
                        value={lastClientDetail.balance.cumulo_indirecto}
                        thousandSeparator="."
                      />
                      &nbsp;
                      <Icon
                        className="detail"
                        handleOnClick={(e) => handleView(e, 'cumulo_indirecto', true)}
                        id="show-cumulo-indirecto"
                        placement="right"
                        tooltipText={<span className="show-tooltip">Ver Tabla</span>}
                      >
                        <FontAwesomeIcon className="table-link" icon={faSearch} />
                      </Icon>
                    </div>
                  </Row>
                </div>
              </Col>
            )}
          </Row>
        )}
        <Row>
          <Col>
            {activeData && (
              <MovimientoListDetail
                handleUpdate={updateFunc}
                id={lastClientDetail.id}
                movimiento={handleKey(activeData)}
                handleEdit={handleEditBorrador}
                setActiveMovement={activeMovementSetter}
                afianzado={lastClientDetail.organizacion}
                update={update}
              />
            )}
          </Col>
        </Row>
      </Container>
    </PageContainer>
  );
};

ClientDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

ClientDetail.defaultProps = {};

export default ClientDetail;
